import Vue from 'vue';
import store from '../store/index.js';
import LoginUserComponent from '../components/menu/login-user-component';
import { ViewObserver, ViewObserverEvent } from '~/utils/view-observer.js';

class HeaderUser {
    constructor(element) {
        ViewObserver.observe(element);
        element.addEventListener(
            ViewObserverEvent.VIEW_ENTER,
            () => {
                this.vm = this.createComponent(element);
            }
        );
    }

    createComponent(el) {
        import(
            /* webpackChunkName: "HeaderUserComponent" */
            '~/components/menu/wide-header-user-component.vue'
        ).then((m) => {
            return new Vue({
                name: 'header-user',
                components: {
                    'dm-wide-header-user': m.default,
                    'dm-login-user': LoginUserComponent
                },
                store,
                el,
                template: `<dm-login-user>
                         <dm-wide-header-user slot-scope="{model}"
                             :model="model" />
                       </dm-login-user>`,
            });
        });
    };
}

[].map.call(document.querySelectorAll('.js-header-user'), function (item) {
    return new HeaderUser(item);
});


